import { render, staticRenderFns } from "./SelectSalutation.vue?vue&type=template&id=663b46bc"
import script from "./SelectSalutation.vue?vue&type=script&lang=js"
export * from "./SelectSalutation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports